<template>
  <v-layout
    row
    wrap
  >
    <v-flex>
      <page-tile-title :has-back-button="true">
        <create-dialog />
      </page-tile-title>
      <!-- end page-tile-title -->

      <v-layout
        v-if="types.length === 0"
        my-3
      >
        <v-flex>
          <v-alert
            :value="types.length === 0"
            type="error"
          >
            Please create type first before creating a company
          </v-alert>
        </v-flex>
      </v-layout>
      <!-- alert here -->

      <v-layout my-3>
        <v-flex>
          <v-card>
            <v-data-table
              :items="items"
              :headers="headers"
              :loading="isLoading"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :disable-initial-sort="true"
            >
              <template v-slot:items="props">
                <td v-text="props.item.name" />
                <td v-text="props.item.location" />
                <td v-text="props.item.phone" />
                <td>
                  <v-layout
                    justify-start
                    grow
                  >
                    <v-chip
                      v-for="(item, index) in props.item.type"
                      :key="index"
                      small
                      label
                      dark
                      color="info"
                    >
                      {{ item.title }}
                    </v-chip>
                    <v-chip
                      v-if="props.item.type.length === 0"
                      small
                      label
                      dark
                      color="error"
                    >
                      N/A
                    </v-chip>
                  </v-layout>
                </td>
                <td v-text="props.item.created_by" />
                <td v-text="props.item.created_at" />
                <td>
                  <!-- buttons here -->
                  <v-layout
                    align-center
                    justify-start
                    class="text-xs-left"
                  >
                    <edit-dialog :item="props.item" />
                    <delete-dialog :item="props.item" />
                  </v-layout>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- end flex -->
  </v-layout>
  <!-- end layout -->
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import PageTileTitle from '@/components/Utilities/PageTileTitle'
import CreateDialog from './components/CreateDialog'
import EditDialog from './components/EditDialog'
import DeleteDialog from './components/DeleteDialog'
export default {
  components: {
    PageTileTitle,
    CreateDialog,
    EditDialog,
    DeleteDialog
  },
  data: () => ({
    headers: [
      {
        text: 'Name',
        sortable: false,
        value: 'name',
        fixed: true,
        width: '300px'
      },
      {
        text: 'Location',
        sortable: false,
        value: 'location',
        fixed: false,
        width: '200px'
      },
      {
        text: 'Phone',
        sortable: false,
        value: 'phone',
        fixed: false,
        width: '200px'
      },
      {
        text: 'Types',
        sortable: false,
        value: 'types',
        fixed: false,
        width: '500px'
      },
      {
        text: 'Created By',
        sortable: false,
        value: 'created_by',
        fixed: false,
        width: '200px'
      },
      {
        text: 'Created At',
        sortable: false,
        value: 'created_at',
        fixed: false,
        width: '200px'
      },
      {
        text: 'Action',
        sortable: false,
        value: false,
        fixed: false,
        width: '300px'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      isLoading: 'clientCompanies/isLoading',
      items: 'clientCompanies/companies',
      rowsPerPageItems: 'clientCompanies/rowPerPageItems',
      paginations: 'clientCompanies/pagination',
      types: 'clientTypes/types',
      logo: 'clientLogo/logo'
    }),
    ...mapState({
      totalItems: state => state.clientCompanies.totalItems,
    }),
    pagination: {
      get () {
        return this.paginations
      },
      set (value) {
        this.getCompanies(value)
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getCompanies(this.page)
      },
      update () {
        this.getCompanies(this.page)
      },
      deep: true
    }
  },
  created () {
    if (this.types.length === 0) {
      this.getTypes({
        page: 1,
        rowsPerPageItem: 10
      })
    }
    if (this.logo.length === 0) {
      this.getLogo(1)
    }
  },
  methods: {
    ...mapActions({
      getCompanies: 'clientCompanies/getCompanies',
      getTypes: 'clientTypes/getTypes',
      getLogo: 'clientLogo/getLogo'
    })
  }
}
</script>
